import React, { useState } from 'react';
import DeleteIncompleteRegisteredBrokerModal from '../brokers/modals/DeleteIncompleteRegisteredBrokerModal';
import EditBrokerModal from '../brokers/modals/EditBrokerModal';
import BrokerUsersTable from './tables/BrokerUsersTable';
import { SectionHeader, BfiCustomStore } from '../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function BrokerUsersSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const gridStore = new BfiCustomStore();

    const [filterTypeId, set_filterTypeId] = useState(0);

    const filterTypes = [
        { id: 0, name: 'All' },
        { id: 1, name: 'Complete Profiles' },
        { id: 2, name: 'Incomplete Profiles' },
        { id: 3, name: 'Closed 10 or More' },
        { id: 4, name: 'Closed 2-9' },
        { id: 5, name: 'Closed 1' },
        { id: 6, name: 'Closed 0' },
    ];

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    brokerUser: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Manage Broker Users' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div>
                    <div
                        className='input-has-icon main-search'
                        style={{
                            width: 'calc(100% - 220px)',
                            borderBottom: '1px solid #cfcfe7',
                            padding: '.5625rem 0 0 0.937rem',
                            height: '58px',
                            position: 'relative',
                            float: 'left',
                        }}
                    >
                        <input
                            type='search'
                            placeholder='Search to Filter Users'
                            value={searchState.searchText?.brokerUser}
                            onChange={_onSearchChange}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            aria-hidden='true'
                            className='icon'
                        />
                    </div>
                    <div
                        className='main-search2'
                        style={{ width: '220px', paddingRight: '20px' }}
                    >
                        <select
                            id='filterTypeId'
                            value={filterTypeId}
                            onChange={(event) => set_filterTypeId(parseInt(event.target.value))}
                        >
                            {filterTypes.map((fs) => {
                                return (
                                    <option
                                        key={fs.id}
                                        value={fs.id}
                                    >
                                        {fs.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className='scrollable-content'>
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <BrokerUsersTable
                            gridStore={gridStore}
                            filter={filterTypeId}
                        />
                    </div>
                </div>
            </div>
            <EditBrokerModal />
            <DeleteIncompleteRegisteredBrokerModal />
        </>
    );
}

export default BrokerUsersSummary;
